import React, { useCallback, useContext, useRef } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { usePopover } from '../../../../Popovers/redux/hooks';
import { PopoverType } from '../../../../Popovers/redux/types';
import AddToGroupPopover from '../../../_partials/AddToGroupPopup';
import AddToGroupButton from '../AddToGroupButton';
import PositionOnlyPopperPopover from '@wix/da-ds/pkg/popper/presets/PositionOnlyPopperPopover';
var offsetModifier = [0, 20];
var AddToGroupButtonWithPopover = function (_a) {
    var deviation = _a.deviation, actionBarType = _a.actionBarType;
    var isMobile = useContext(MobileContext);
    var toggleRef = useRef(null);
    var _b = usePopover(actionBarType === 'primary'
        ? PopoverType.ADD_TO_GROUP_PRIMARY
        : PopoverType.ADD_TO_GROUP_SECONDARY), popover = _b.popover, pushPopover = _b.pushPopover, removePopover = _b.removePopover;
    var togglePopover = function () {
        if (popover.isOpen) {
            removePopover();
        }
        else {
            pushPopover();
        }
    };
    var handleOnClickOutside = useCallback(function (e) {
        if ((toggleRef.current && toggleRef.current.contains(e.target)) ||
            isMobile) {
            return;
        }
        removePopover();
    }, [removePopover, isMobile]);
    return (React.createElement(PositionOnlyPopperPopover, { ref: toggleRef, popoverContent: React.createElement(AddToGroupPopover, { actionbarType: actionBarType, deviation: deviation, onClose: removePopover }), isVisible: popover.isOpen, placement: "bottom", offsetModifier: offsetModifier, onClickOutside: handleOnClickOutside },
        React.createElement(AddToGroupButton, { activated: popover.isOpen, deviation: deviation, onClick: togglePopover, withTooltip: !popover.isOpen })));
};
AddToGroupButtonWithPopover.displayName = 'AddToGroupButtonWithPopover';
export default AddToGroupButtonWithPopover;
//# sourceMappingURL=AddToGroupButtonWithPopover.js.map